// Helper to decide if the unified triggering-event intake should be shown
// Inputs are the GraphQL `getCurrentUser` shape (features, triggering_events, company.feature_types)
export function shouldShowUnifiedIntake(currentUser) {
  if (!currentUser) return false;

  const url = new URL(window.location.href);
  const forceShow = url.searchParams.get('forceIntake') === '1';
  const forceHide = url.searchParams.get('hideIntake') === '1';
  if (forceShow) return true;
  if (forceHide) return false;

  // Do not hard-require a feature flag; default to showing intake when needed.

  // Snooze until next browser session
  const snoozed = sessionStorage.getItem('unifiedIntakeSnoozed') === '1';
  if (snoozed) return false;

  // Determine completion across four triggering events
  const completed = new Set(
    (currentUser?.triggering_events || [])
      .filter(e => e && e.completed_at)
      .map(e => e.event_type)
  );
  // Show intake ONLY until the first triggering event is completed.
  // Once any event is done (and the Action Plan exists), we move users to the dashboard.
  return completed.size === 0;
}

export function snoozeUnifiedIntakeForSession() {
  try { sessionStorage.setItem('unifiedIntakeSnoozed', '1'); } catch (_) {}
}

// Show assessment prompt empty-states when user has not completed any
// triggering events. Unlike overlay gating, this ignores snooze and URL flags.
export function shouldShowAssessmentPrompt(currentUser) {
  if (!currentUser) return false;
  try {
    const url = new URL(window.location.href);
    if (url.searchParams.get('forcePrompt') === '1') return true;
    if (url.searchParams.get('hidePrompt') === '1') return false;
  } catch (_) {}
  const completed = new Set(
    (currentUser?.triggering_events || [])
      .filter(e => e && e.completed_at)
      .map(e => e.event_type)
  );
  return completed.size === 0;
}


